import { FrequencyType, ProductSummaryModel } from '../../../models/Cart';
import { resources } from '../../../resources/resources';

export const getSalaryTaxesMessage = (
  salaryTaxes: number,
  hasBudgetTaxes: boolean,
): string => {
  if (salaryTaxes === 0) {
    return hasBudgetTaxes
      ? resources.cart.summary.salaryTaxes.infoNoTaxes.withBudgetTaxes
      : resources.cart.summary.salaryTaxes.infoNoTaxes.withoutBudgetTaxes;
  } else return resources.cart.summary.salaryTaxes.info;
};

export const getBudgetTaxesMessage = (
  budgetTaxes: number,
  isGrossUp: boolean,
): string => {
  if (isGrossUp) return resources.cart.summary.budgetTaxes.infoGrossUp;
  if (budgetTaxes === 0) return resources.cart.summary.budgetTaxes.infoNoTaxes;
  return resources.cart.summary.budgetTaxes.info;
};

export const isGrossup = (products: ProductSummaryModel[]): boolean => {
  return products.some(p => p.budgetTaxes > 0 && p.salaryTaxes === 0);
};

export const mapRecurringFrequency = (
  frequency: FrequencyType,
  duration: number,
) => {
  switch (frequency) {
    case FrequencyType.Daily:
      return duration === 1
        ? resources.cart.summary.daily
        : resources.cart.summary.days;
    case FrequencyType.Weekly:
      return duration === 1
        ? resources.cart.summary.weekly
        : resources.cart.summary.weeks;
    case FrequencyType.Monthly:
      return duration === 1
        ? resources.cart.summary.monthly
        : resources.cart.summary.months;
    case FrequencyType.Yearly:
      return duration === 1
        ? resources.cart.summary.yearly
        : resources.cart.summary.years;
    default:
      return '';
  }
};
